import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getWithdrawalsAwaiting = (params) => {
    return axios.get(`${backendHost}/api/admin/withdrawal/awaiting/list`, {params});
};

export {
    getWithdrawalsAwaiting
}